import { api } from "../common/js/api";

const Module = {
  binded: false,
  async check(router) {
    if (!____isWechatBrowser()) return;
    if (Module.binded) return;
    const res = await api.getUserInfo();
    if (res.data.status == 1) {
      const { source, mobilePhone } = res.data.result.xfpUser;
      if (!source || !mobilePhone) {
        router.replace({
          path: '/personal/bindUserInfo',
          query: {
            returnUrl: router.currentRoute.fullPath,
          }
        });
      } else {
        Module.binded = true;
      }
    }
  },
};

export default Module;
